import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field } from 'formik'

interface Props {}

export const DemolitionTechnicalFormB1B: React.FC<Props> = (props) => {
  return (
    <FormSectionTwoColumns
      title="b) stávající parametry odstraňované stavby"
      subtitle="například zastavěná plocha, obestavěný prostor, počet funkčních jednotek"
      sectionKey="b1b"
    >
      <>
        <div className="sm:col-span-6">
          <Field
            name="b1b.buildingParameters"
            label="Stávající parametry odstraňované stavby"
            component={RichTextInput}
            aiHint={
              'Stávající parametry odstraňované stavby - zastavěná plocha, obestavěný prostor, počet funkčních jednotek'
            }
          />
        </div>
      </>
    </FormSectionTwoColumns>
  )
}
